import { render, staticRenderFns } from "./cow-pregnancy.vue?vue&type=template&id=cb6a786a&scoped=true&"
import script from "./cow-pregnancy.vue?vue&type=script&lang=js&"
export * from "./cow-pregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6a786a",
  null
  
)

export default component.exports